import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import SkeletonGrid from '@zenbusiness/zui/SkeletonGrid';
import Text from '@zenbusiness/zui/Text';
import useBreakpoints from '@zenbusiness/zui/useBreakpoints';

import { useBusinessEntities } from '#client/hooks/useBusinessEntities';
import { BusinessEntityCard } from '#client/pages/BusinessOverview/BusinessEntityCard';

import * as Styled from './BusinessOverview.style';

const BusinessOverview = () => {
  const { sizes } = useBreakpoints();

  const { loading, businessEntities } = useBusinessEntities();

  const renderContent = () => {
    if (loading) {
      let columns = sizes.isDesktop ? 3 : 2;
      columns = sizes.isMobile ? 1 : columns;

      return <SkeletonGrid columns={columns} count={6} />;
    }

    return (
      <Styled.ListCard>
        {businessEntities.map(({ uuid, name }) => (
          <Styled.ListItem key={uuid}>
            <BusinessEntityCard uuid={uuid} name={name} />
          </Styled.ListItem>
        ))}
      </Styled.ListCard>
    );
  };

  return (
    <Styled.Container>
      <Styled.Header
        title={
          <Text size="2xl">
            <FormattedMessage id="dashboard.businessOverview.title" />
          </Text>
        }
      />
      {renderContent()}
    </Styled.Container>
  );
};

export default BusinessOverview;
